'use client';
import { jsx } from 'react/jsx-runtime';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, r) {
    if (null == e) return {};
    var o, t, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(t = 0; t < i.length; t++)o = i[t], !(r.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(e, o) && (n[o] = e[o]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var o, t, n = {}, i = Object.keys(e);
    for(t = 0; t < i.length; t++)o = i[t], r.indexOf(o) >= 0 || (n[o] = e[o]);
    return n;
}
const PriceBar = renderWithRef('PriceBar', null, (o, a)=>{
    useComponentStylesLoaded('PriceBar', SWAN_STYLE_KEY_MAP.priceBar), useDeprecatedProps('PriceBar', o, [
        {
            propName: 'showBannerOnly',
            instructions: 'To maintain a high-quality user experience, we are no longer supporting this feature, and are not providing a direct replacement.'
        }
    ]);
    let { showBannerOnly: s = false, children: c } = o, p = _object_without_properties(o, [
        "showBannerOnly",
        "children"
    ]), l = new Set([
        'swan-price-bar'
    ]);
    return s && l.add("swan-price-bar-show-banner"), jsx(RenderComp, {
        root: "div",
        forwardedRef: a,
        classNames: l,
        props: p,
        children: jsx("div", {
            className: "swan-price-bar-inner",
            children: c
        })
    });
});

export { PriceBar };
